import * as React from 'react';
export const microsoftSvg = React.forwardRef(function microsoftSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 .097h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.505 15.602H6V6.097h9.505v9.505Z',
      fill: '#F1511B',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M26 15.602h-9.505V6.097H26v9.505Z',
      fill: '#80CC28',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.505 26.1H6v-9.505h9.505v9.504Z',
      fill: '#00ADEF',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M26 26.1h-9.505v-9.505H26v9.504Z',
      fill: '#FBBC09',
    }),
  );
});
microsoftSvg.defaultProps = {
  width: '32',
  height: '33',
  viewBox: '0 0 32 33',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var microsoft = {
  category: 'brand',
  colorable: false,
  name: 'microsoft',
  svg: microsoftSvg,
};
